const Eyebrow = ({ children, className = "" }) => (
  <span
    className={`inline-block text-xs font-semibold uppercase tracking-[0.2em] text-[var(--website-primary-color)] ${className}`}
  >
    {children}
  </span>
);

export default Eyebrow;
